import * as Immutable from "immutable";
import { createSelectorCreator, defaultMemoize } from "reselect";

export const createImmutableIsEqualSelector = createSelectorCreator(defaultMemoize, Immutable.is);
